export const getters = {
	currentSite: (state) => state.site,
	currentTheme: (state) => (state.site ? state.site.theme : null),
	cgpiHost: (state) => state.site.hosts.find((host) => host.name === 'app_cgpi'),
	clientHost: (state) => state.site.hosts.find((host) => host.name === 'app_client')
}



// WEBPACK FOOTER //
// ./src/common/store/Site/getters.js